import { render, staticRenderFns } from "./BalanceEmpower.vue?vue&type=template&id=c321fdbc&scoped=true&"
import script from "./BalanceEmpower.vue?vue&type=script&lang=js&"
export * from "./BalanceEmpower.vue?vue&type=script&lang=js&"
import style0 from "./BalanceEmpower.vue?vue&type=style&index=0&id=c321fdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c321fdbc",
  null
  
)

export default component.exports